export const DISPATCH_CHANNELS = [
    { code: 'email', label: 'E-Mail', manual: false },
    { code: 'print', label: 'PDF / Druck', manual: false },
    { code: 'post', label: 'Post', manual: true },
    { code: 'handover', label: 'Persönlich übergeben', manual: true },
    { code: 'fax', label: 'Fax', manual: true },
    { code: 'portal', label: 'Kundenportal / Upload', manual: true },
    { code: 'other', label: 'Sonstiger Weg', manual: true },
];
export function dispatchChannelLabel(code) {
    return DISPATCH_CHANNELS.find((entry) => entry.code === code)?.label ?? code;
}
//# sourceMappingURL=dispatch.js.map